<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:22:34
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-01 16:00:15
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div class="card" style="width: 2.71rem; height: 1.46rem">
    <div class="card-header">
      <div>公告专栏</div>
      <div class="more">更多</div>
    </div>
    <Tabs :animated="false">
        <TabPane label="招标公告">
          <div class="info" v-for="(item,index) in 5" :key="index" >
            <div class="tips-333">关于蘸料&小料台品类的邀标公告</div>
            <div>2024-01-01</div>
          </div>
        </TabPane>
        <TabPane label="创新公告">标签二的内容</TabPane>
        <TabPane label="工作模板">标签二的内容</TabPane>
        <TabPane label="知识产权">标签二的内容</TabPane>
    </Tabs>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {}
  },
  computed: {},
  created () {},
  methods: {}
}
</script>
